// The backend requires a Bearer token on every /api/* request (added
// alongside the login gate). Many pre-existing components across the app
// call the browser's fetch() directly instead of the authenticated
// apiRequest()/queryClient wrapper, so without this patch they would all
// start failing with 401 as soon as the auth gate went live. Patching
// fetch once here, globally, is far safer than hunting down and rewriting
// dozens of scattered call sites by hand.
const TOKEN_KEY = "rently_token";
const originalFetch = window.fetch.bind(window);

function isApiPath(input: RequestInfo | URL): boolean {
  try {
    const url =
      typeof input === "string"
        ? input
        : input instanceof URL
          ? input.toString()
          : input.url;
    const path = url.startsWith("http")
      ? new URL(url, window.location.origin).pathname
      : url;
    return path.startsWith("/api/");
  } catch {
    return false;
  }
}

window.fetch = ((input: RequestInfo | URL, init?: RequestInit) => {
  if (!isApiPath(input)) return originalFetch(input, init);

  let token: string | null = null;
  try {
    token = localStorage.getItem(TOKEN_KEY);
  } catch {
    // ignore
  }
  if (!token) return originalFetch(input, init);

  const headers = new Headers(
    init?.headers ?? (input instanceof Request ? input.headers : undefined),
  );
  if (!headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  return originalFetch(input, { ...init, headers });
}) as typeof window.fetch;
